import { parsePhoneNumber } from 'libphonenumber-js'
import * as Yup from 'yup'

Yup.addMethod(Yup.string, 'validateApplicationPhone', function (errorMessage) {
  return this.test('test-application-phone', errorMessage, function (value) {
    const { path, createError } = this

    if (!value || value.length < 10) {
      return createError({ path, message: errorMessage })
    }

    try {
      const parsed = parsePhoneNumber(value, 'US')

      return !!parsed?.isValid() || createError({ path, message: errorMessage })
    } catch {
      return createError({ path, message: errorMessage })
    }
  })
})

/**
 * The market field is only required when the opportunity spans more than one market. With a single market it is
 * pre-filled and never rendered as a control, so requiring it would block a valid submission.
 */
export const buildOpportunityApplicationSchema = (isMultiMarket: boolean) =>
  Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    email: Yup.string().required('Email address is required').email('Email is invalid'),
    phone: Yup.string()
      .required('Phone number is required')
      // @ts-ignore — validateApplicationPhone is registered on the prototype above, so TS cannot see it
      .validateApplicationPhone('Phone number is invalid'),
    vehicleType: Yup.string().required('Select the vehicle you will drive'),
    partnerMarketId: isMultiMarket
      ? Yup.string().required('Select the market you want to work in')
      : Yup.string(),
    acceptOptIn: Yup.boolean()
      .required('You must agree to receive SMS messages to proceed')
      .oneOf([true], 'You must agree to receive SMS messages to proceed'),
  })
